import { JSX } from "preact/jsx-runtime";
import { useIsMobile } from "../../hooks/useIsMobile";
import { Notification, NotificationType } from "./Notification";
import styles from "./NotificationContainer.module.scss";

export interface NotificationItem {
  id: string;
  type: NotificationType;
  message: string | JSX.Element;
  duration?: number;
  slotId?: 1 | 2;
}

interface NotificationContainerProps {
  notifications: NotificationItem[];
  onRemove: (id: string) => void;
  variant?: "global" | "inline";
  className?: string;
}

export const NotificationContainer = ({
  notifications,
  onRemove,
  variant = "global",
  className = "",
}: NotificationContainerProps) => {
  if (notifications.length === 0) return null;

  const containerClass = `${
    variant === "inline" ? styles.containerInline : styles.container
  } ${className}`.trim();

  const isMobile = useIsMobile();

  if (variant === "inline" && !isMobile) {
    const left = notifications.filter(
      (n) => n.slotId === 1 || n.slotId == null
    );
    const right = notifications.filter((n) => n.slotId === 2);

    return (
      <div className={`${styles.containerInline} ${styles.desktopSlots}`}>
        <div className={styles.slotCol}>
          {left.map((notification) => (
            <Notification
              key={notification.id}
              type={notification.type}
              onClose={() => onRemove(notification.id)}
              duration={notification.duration}
            >
              {notification.message}
            </Notification>
          ))}
        </div>
        <div className={styles.slotCol}>
          {right.map((notification) => (
            <Notification
              key={notification.id}
              type={notification.type}
              onClose={() => onRemove(notification.id)}
              duration={notification.duration}
            >
              {notification.message}
            </Notification>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={containerClass}>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          type={notification.type}
          onClose={() => onRemove(notification.id)}
          duration={notification.duration}
        >
          {notification.message}
        </Notification>
      ))}
    </div>
  );
};
